export const AutograderLevel = {
  RULESET: 'ruleset',
  RULESET_CRITERION: 'ruleset criterion',
  RULE: 'rule',
  CHECK: 'check',
};

export const OTHER_PROPS = 'otherProps';
